/**
 * Calculate the new quota based on the previous quota and the score.
 * @param {number} previousQuota - The previous quota of the player.
 * @param {number} score - The player's score for the event.
 * @returns {number} - The calculated new quota.
 */
function calculateQuota(previousQuota, score) {
  
  if (previousQuota == null) {
    return 0; // Default to 0 if invalid
  }
  if (score == null) { // Only check for null or undefined, not 0
    return previousQuota;
  }

  const difference = score - previousQuota;


  let newQuota;
  if (difference >= -2) {
    newQuota = Math.round((difference / 2) + previousQuota);
  } else {
    newQuota = Math.round(previousQuota - 2);
  }

  return newQuota;
}

module.exports = calculateQuota;
